import { FC } from 'react'

import { HStack, IconButton, Text } from '@revolut-internal/ui-kit'

import { RangeDirection, TimeRange } from 'modules/Monitoring/types'
import { formatDateRange } from 'modules/Monitoring/utils/time/formatDateRange'

type TimeRangePaginationProps = {
  range: TimeRange
  withTime: boolean
  hasNext: boolean
  onRangeChange: (direction: RangeDirection) => void
}

export const TimeRangePagination: FC<TimeRangePaginationProps> = ({
  range,
  withTime,
  hasNext,
  onRangeChange,
}) => {
  if (!range) {
    return null
  }

  return (
    <HStack space="s-48" align="center">
      <IconButton
        useIcon="ChevronLeft"
        color="grey-tone-50"
        iconOnly
        onClick={() => onRangeChange(RangeDirection.Previous)}
      >
        Previous range
      </IconButton>

      <Text>{formatDateRange(range, withTime)}</Text>

      <IconButton
        useIcon="ChevronRight"
        color={!hasNext ? 'grey-tone-10' : 'grey-tone-50'}
        disabled={!hasNext}
        iconOnly
        onClick={() => onRangeChange(RangeDirection.Next)}
      >
        Next range
      </IconButton>
    </HStack>
  )
}
